import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";
import { fetchAlumnoInscrito } from "./alumnoInscritoSlice";


interface GrupoState {
    status: string;
    error: string;
    grupoList: any[],
    grupoListActive: any[],
    grupo: {
        idGrupo: number | null;
        idCiclo: number | null;
        nombre: string | null;
        descripcion: string | null;
        urlGrupo: string | null;
        idFacilitador: number | null;
        horario: string | null;
        alumnos: number | null;
        observaciones: string | null;
        estado: number | null;
    }

}

const initialState: GrupoState = {
    status: 'idle',
    error: '',
    grupoList: [],
    grupoListActive: [],
    grupo: {
        idGrupo: null,
        idCiclo: null,
        nombre: null,
        descripcion: null,
        urlGrupo: null,
        idFacilitador: null,
        horario: null,
        alumnos: null,
        observaciones: null,
        estado: null
    }
}

export const fetchGrupo = createAsyncThunk('fetchGrupo', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 106;
    const { result, message, data } = await getData({ idsp, idCiclo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateGrupo = createAsyncThunk('modifyCreateGrupo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const grupoNew = selectGrupo(state);
    const grupoAttributes = { ...grupoNew };
    const idCiclo = grupoAttributes.idCiclo;
    const idsp = grupoAttributes.idGrupo ? 104 : 103;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...grupoAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }

    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchGrupo({ idCiclo }));
    return rejectWithValue(message);
});

export const deleteGrupo = createAsyncThunk('deleteGrupo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const grupoNew = selectGrupo(state);
    const grupoAttributes = { ...grupoNew }
    const idGrupo = grupoAttributes.idGrupo;
    const idCiclo = grupoAttributes.idCiclo;
    const idsp = 107;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, idGrupo }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchGrupo({ idCiclo }));
    return rejectWithValue(message);
});

export const asignarGrupo = createAsyncThunk('asignarGrupo', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 115;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, idCiclo }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }

    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchGrupo({ idCiclo }));
    dispatch(fetchAlumnoInscrito({ idCiclo }));
    return rejectWithValue(message);
});

export const grupoSlice = createSlice({
    name: 'grupo',
    initialState,
    reducers: {
        setGrupoList: (state, action) => {
            state.grupoList = action.payload;
        },
        setGrupoListActive: (state, action) => {
            state.grupoListActive = action.payload;
        },
        setGrupo: (state, action) => {
            state.grupo = !action.payload ? initialState.grupo : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchGrupo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchGrupo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.grupoList = data ? data.map((grupo: any) => ({
                    ...grupo,
                    facilitadorNombre: grupo.TIP?.[0]?.primerNombre || null,
                    facilitadorApellido: grupo.TIP?.[0]?.primerApellido || null,
                    alumnos: grupo.TIP?.[0]?.alumnos ?? 0
                })) : [];

            })
            .addCase(fetchGrupo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectGrupoList = (state: RootState) => state.grupo.grupoList;
export const selectGrupoListActive = (state: RootState) => state.grupo.grupoListActive;
export const selectGrupo = (state: RootState) => state.grupo.grupo;

export const { setGrupoList, setGrupoListActive, setGrupo } = grupoSlice.actions;

export default grupoSlice.reducer;